(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 4217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(7141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Footer.tsx
var Footer = __webpack_require__(4260);
// EXTERNAL MODULE: ./components/Header.tsx
var Header = __webpack_require__(3505);
;// CONCATENATED MODULE: ./components/PrivacyPolicy.tsx

/* harmony default export */ var PrivacyPolicy = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: "#f3f3f3"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex-1 overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-10 pt-20 max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-bold text-xl mb-12 text-center",
                            children: "Privacy Policy"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: 'This website and platform is operated by Artwishlist Ltd (trading as Facture.art) (company number: 09311563) ("we" or "us") and this policy relates to your use of our website and platform.'
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: 'We are a "data controller" for the purposes of the Data Protection Act 2018, the UK GDPR and the EU General Data Protection Regulation 2016/679. This means that we are responsible for, and control the processing of, the personal data that we collect about you.'
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "We are committed to protecting and respecting your privacy. We take your privacy very seriously and we ask that you read this Policy carefully as it contains important information on:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "the personal data we collect about you;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "how we process your personal data; and"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "with whom your personal data might be shared."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mb-6 font-bold",
                            children: "Personal data which we collect"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 underline",
                            children: "Personal data provided by you"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "We collect personal data about you when you:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "visit our website and interact with it;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "register with us on our platform;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "interact with our platform;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "make payments for any of our services;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "contact us through our platform;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "post material on our platform;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "sign up for our newsletter via our website or platform."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "The personal data collected in the above manner may include the following categories and types of personal data:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Identity Data: full name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Contact Data: postal address; email address; telephone number;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Financial Data: payment details; billing address;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Transaction Data: details about payments to and from you regarding your subscription;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Technical Data: internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access our website or platform"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Marketing Data: your preferences in receiving our newsletter"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "We do not collect any special category data about you."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 underline",
                            children: "Personal data about other individuals"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "If you give us information on behalf of someone else, you confirm that the other person has appointed you to act on his/her behalf and has agreed that you can:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "give consent on his/her behalf to the processing of his/her personal data;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "receive on his/her behalf any data protection notices; and"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "give consent to the transfer of his/her personal data abroad."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "How we use your personal data"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "Your personal data will be processed to for the following purposes:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "To fulfil our contractual responsibilities with you - for example, to provide the platform services to you in receipt of payment by you. The legal basis for this processing is contractual necessity."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "To meet our management responsibilities, which are necessary for the organisational functioning of the platform. The legal basis for this processing is legitimate interests, specifically in respect of the proper administration of our business."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "To comply with our legal obligations."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "More information about how we use your personal data, as well as the categories of personal data involved in our legal bases, is set out in the table. We will only use your personal data for the purposes for which we collected it. If we need to use your personal information for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex-1 overflow-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto px-10 max-w-4xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "border border-slate-500 my-12 table-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    style: {
                                        background: "#ccc"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "Purpose for Processing"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "Categories of Personal Data"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "Legal Basis"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Identify you and manage any accounts you hold with us"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Contact Data"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Entering into/performance of our contract with you"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Process your order/ongoing subscription"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Contact Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Financial Data"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Entering into/performance of our contract with you"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Conduct research, statistical analysis and behavioural analysis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Technical Data"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Legitimate interest (overseeing platform performance and determining how it/our services can be improved)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Carry out customer profiling and analyse your purchasing preferences"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Technical Data"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Legitimate interests (overseeing platform performance and determining how it/our services can be improved)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Detect and prevent fraud"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Contact Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Financial Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Technical Data"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Legitimate interests in compliance with legal obligations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Customise our website, platform and content to your particular preferences"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Technical Data"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Legitimate interest (overseeing platform performance and determining how it/our services can be improved)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Improve our website, our platform and our services"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Technical Data"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Legitimate interests (overseeing platform performance and determining how it/our services can be improved)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Send you our newsletter"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity Data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Contact Data"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Consent"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex-1 overflow-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-10 max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "When we might share your personal data with Third parties"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "For the purposes of delivering our services, we may disclose your personal data to:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "other companies within our group;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "third party service providers, such as our payment processors;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "law enforcement agencies in connection with any investigation to help prevent unlawful activity; and"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "In addition to the specific disclosures of personal data set out in this clause, we may disclose your personal data where such disclosure is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "Consent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "In those cases where we need your consent to hold and process your personal data, we will ask you to check a box on any form requiring consent. By checking these boxes you are stating that you have been informed as to why we are collecting the information, how it will be used, for how long it will be kept, who else will have access to it and what your rights are as a data subject (all of which is set out in this policy)."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "Please note that we may process your personal information without your knowledge or consent where this is required or permitted by law."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "How we keep your personal data secure"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "To protect your information, we have policies and procedures in place to make sure that only authorised personnel can access the information, that information is handled and stored in a secure and sensible manner, and that all systems that can access the information have the necessary security measures in place. To accomplish this, all employees have roles and responsibilities defined in those policies and procedures."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "In additional to these operational measures we also use a range of technologies and security systems to reinforce the policies, including ensuring that:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "access to your account is controlled by a password and user name that are unique to you; and"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "we store your personal data on secure servers."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "How long do we keep your personal data"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "Personal data that we process for any purpose(s) shall not be kept for longer than is necessary for that purpose(s)."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "We may retain your personal data where such retention is necessary for compliance with a legal, accounting or reporting obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "In some circumstances, we may anonymise your personal information so that it can no longer be associated with you, in which case we may use that information without further notice to you."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "Transfers of your personal data out of the UK and the EEA"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "We may need to transfer your personal data to external third parties that are which are based outside of the UK and the EEA, for the purpose of billing you and sending our newsletter to you."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "Whenever we transfer your personal data out of the UK and the EEA, we ensure a similar degree of protection is afforded to it by ensuring at least one of the following safeguards is implemented:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "we will only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data; and,"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "where we use certain service providers, we may use specific contracts for use in the UK and the EEA which give personal data the same protection it has in the UK and the EEA."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "Your rights"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "In order to process any of the requests listed below, we may need to verify your identity for your security. In such cases your response will be necessary for you to exercise this right."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to access information we hold on you:"
                                }),
                                " ",
                                "At any point you can contact us to request the information we hold on you as well as why we have that information, who has access to the information and where we got the information. Once we have received your request, we will respond within 30 days. You will not have to pay a fee to access your personal information (or to exercise any of the other rights). However, we may charge a reasonable fee if your request for access is clearly unfounded or excessive. Alternatively, we may not be able to supply you with a copy of your personal data, if it would infringe the rights and freedoms of others, or we are legally entitled to withhold it."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to correct and update the information we hold on you:"
                                }),
                                " ",
                                "If the data we hold on you is out of date, incomplete or incorrect, you can inform us and we will ensure that it is updated."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to have your information erased:"
                                }),
                                " ",
                                "If you feel that we should no longer be using your data or that we are illegally using your data, you can request that we erase the data we hold. When we receive your request, we will confirm whether the data has been deleted or tell you the reason why it cannot be deleted."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to object to processing of your data:"
                                }),
                                " ",
                                "You have the right to request that we stop processing your data. Upon receiving the request, we will contact you to tell you if we are able to comply or if we have legitimate grounds to continue. If data is no longer processed, we may continue to hold your data to comply with your other rights."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to ask us to stop contacting you with direct marketing:"
                                }),
                                " ",
                                "You have the right to request that we stop contacting you with direct marketing. In order to process your request we may need to verify you identity for your security."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to data portability:"
                                }),
                                " ",
                                "You have the right to request that we transfer your data to another controller. Once we have received your request, we will comply where it is feasible to do so."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline",
                                    children: "The right to complain:"
                                }),
                                " You can make a complaint to us by contacting us via contact@facture.art or to the data protection supervisory authority – in the UK, this is the Information Commissioner's Office, at https://ico.org.uk/."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "Cookies and tracking"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 underline",
                            children: "Use of cookies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "A cookie is a small text file which is placed onto your electronic device when you access our platform. We use cookies on this platform to:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb-6 ml-12 list-disc space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "recognise you whenever you visit this platform;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "obtain information about your preferences, online movements and use of the internet;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "carry out research and statistical analysis to help improve our content and services and to help us better understand our customer requirements and interests; and"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "make your online experience more efficient and enjoyable."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "In most cases we will need your consent in order to use cookies on this platform. The exception is where the cookie is essential in order for us to provide you with a product or service you have requested."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 underline",
                            children: "Consent to cookies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "If you visit our website when your browser is set to accept cookies, we will interpret this as an indication that you consent to our use of cookies and other similar technologies as described in this Policy. If you change your mind in the future about letting us use cookies, you can modify the settings of your browser to reject cookies or disable cookies completely."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 underline",
                            children: "Consent to cookies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "The table below provides some information on the cookies which we use on our website:"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex-1 overflow-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto px-10 max-w-4xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "border border-slate-500 my-12 table-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    style: {
                                        background: "#ccc"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "Cookie Name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "What it does"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "Why is it used"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "border border-slate-600 p-4 pl-8",
                                            children: "How long it lasts"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "auth0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Functionality cookie - creates a login token for the user"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "So that the user does not need to log in every time they return to the site."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "400 days"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Mouseflow"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Analytics cookie - allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "border border-slate-600 p-4 pl-8",
                                                children: "Expires immediately upon leaving the site"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex-1 overflow-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-10 max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 underline",
                            children: "Turning off cookies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "If you do not want to accept cookies, you can change your browser settings so that cookies are not accepted. If you do this, please be aware that you may lose some of the functionality of the platform. For further information about cookies and how to disable them please go to the Information Commissioner's webpage on cookies:",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://ico.org.uk/for-the-public/online/cookies",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "https://ico.org.uk/for-the-public/online/cookies"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "Contacting us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "You may exercise your rights in relation to your personal data by written notice to us. This should be by email to",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:contact@facture.art",
                                    children: "contact@facture.art"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "If you consider that our processing of your personal data infringes data protection legislation, you have a legal right to lodge a complaint with a supervisory authority responsible for data protection. In the United Kingdom, the supervisory authority is the Information Commissioner's Office (ICO) and further details about your rights and the ICO's complaints procedure is available via the following link:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://ico.org.uk/concerns",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "https://ico.org.uk/concerns"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6 font-bold",
                            children: "Changes to this policy"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "We may change this Policy from time to time. You should check this Policy occasionally to ensure that you are aware of the most recent version that will apply each time you access the website."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-6",
                            children: "Where we have made any changes to this Policy which affects the manner in which we use your personal data, we will contact you by email to inform you of this change."
                        })
                    ]
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/Menu.tsx
var Menu = __webpack_require__(3619);
;// CONCATENATED MODULE: ./pages/privacy-policy.tsx







const Index = ()=>{
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Facture - Privacy Policy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                        onMenuOpen: ()=>setMenuOpen(!menuOpen)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        onMenuOpen: ()=>setMenuOpen(!menuOpen),
                        open: menuOpen
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var privacy_policy = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [247,535,774,888,179], function() { return __webpack_exec__(4217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);